module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "hd-right"
  }, [_vm._t("right")], 2), _vm._v(" "), _c('div', {
    staticClass: "hd-left"
  }, [_vm._t("left")], 2), _vm._v(" "), _c('h5', {
    staticClass: "title",
    on: {
      "click": _vm.toGo
    }
  }, [_vm._t("title")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3b56578!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/heads.vue
// module id = 135
// module chunks = 2